import * as React from "react";
import { ISatisfactorySurveryProps } from "./Types";
import { SatisfactoryLevel, TypeOfFinalTransaction, ErrorCodes, ClientEventScreen } from "../../dtos/KioskDtos.dtos";
import { TitlesLang } from "../../resources/TitlesLang";
import { MessagesAndInstructionsLang } from "../../resources/MessagesAndInstructionsLang";
import { getErrorMessages, getRedirectPatientMessage } from "../../services/Language/GetErrorMessages";
import Client from "../../services/Client";
import TimerManager from "../../services/TimerManager";

const greenSuccessImg = require("../../assets/images/successful-checkmark.png");
const satisfactoryFace = require('../../assets/images/Satisfactory.png');
const unsatisfactoryFace = require('../../assets/images/Unsatisfactory.png');
const failImage = require('../../assets/images/fail-error.png');

const getTitleString = (titles: TitlesLang, type: TypeOfFinalTransaction) => {
    switch (type) {
        case TypeOfFinalTransaction.PatientInformedOfLateAppointments:
        case TypeOfFinalTransaction.PatientInformedOfFutureOnlyAppointments:
        case TypeOfFinalTransaction.NewAppointmentCreatedAndConfirmed:
        case TypeOfFinalTransaction.ExistingAppointmentConfirmed:
            return titles.AppointmentConfirmationTitle;

        case TypeOfFinalTransaction.CancelledOnTheirOwn:
            return titles.PatientCancelledCheckinTitle

        case TypeOfFinalTransaction.EncounteredError:
            return titles.ErrorTitle

        default:
            return "";
    }
}

export const getMainMessage = (messages: MessagesAndInstructionsLang, type: TypeOfFinalTransaction, errorCode: ErrorCodes = ErrorCodes.None): React.ReactNode => {
    const successfulMessage = (message: string) => <><img src={greenSuccessImg} className="popup-image-size" />{message}</>

    switch (type) {
        case TypeOfFinalTransaction.ExistingAppointmentConfirmed:
        case TypeOfFinalTransaction.NewAppointmentCreatedAndConfirmed:
            return successfulMessage(messages.AppointmentHasBeenConfirmedMessage);

        case TypeOfFinalTransaction.CancelledOnTheirOwn:
            return <>{messages.PatientCancelledCheckinMessage}</>

        case TypeOfFinalTransaction.EncounteredError:
            return <><img src={failImage} className="popup-image-size" />{`${getErrorMessages(messages, errorCode)} ${getRedirectPatientMessage(messages, errorCode)}`}</>

        default:
            return null;
    }
}

export const SatisfactorySurvery = (props: ISatisfactorySurveryProps) => {
    React.useEffect(() => {
        let timer = null;
        if (props.surveySubmitted) {
            timer = setTimeout(props.exit, 10000);
        }
        return () => clearTimeout(timer);
    }, [props.surveySubmitted])

    React.useEffect(() => TimerManager.setCurrentScreen(ClientEventScreen.SatisfactorySurvey), [])

    const rateYourExperienceSection = () => (
        <>
            <div>
                <h1 style={{ marginBottom: "50px" }}>{props.text.messagesInstructions.HowWouldYourRateMessage}</h1>
            </div>
            <div>
                <div style={{ display: "flex", justifyContent: "space-around" }}>
                    <img src={satisfactoryFace} onClick={() => props.postAnswer(SatisfactoryLevel.Satisfactory, props.typeOfFinalTransactionCompleted, props.errorCode)} />
                    <img src={unsatisfactoryFace} onClick={() => props.postAnswer(SatisfactoryLevel.Unsatisfactory, props.typeOfFinalTransactionCompleted, props.errorCode)} />
                </div>
            </div>
        </>
    )

    const renderRatingCompletedMessage = () => {
        switch (props.typeOfFinalTransactionCompleted) {
            case TypeOfFinalTransaction.ExistingAppointmentConfirmed:
                return <h1 style={{ marginBottom: "50px" }}>{props.text.messagesInstructions.ProcedeToWaitingRoomInstruction}</h1>
            default:
                return <h1 style={{ marginBottom: "50px" }}>{props.text.messagesInstructions.PleaseSeeReceptionMessage}</h1>
        }
    }

    const ratingCompleteComponent = () => (
        <>
            <div>
                {renderRatingCompletedMessage()}
            </div>
            <div>
                <h1 style={{ marginBottom: "50px" }}>{props.text.messagesInstructions.ThankYouForUsingMyleKioskMessage}</h1>
            </div>
        </>
    )

    return (
        <div>
            <div className="row">
                <div className="col-md-12 header">
                    <div>
                        <h1 className="clinic-header">{getTitleString(props.text.titles, props.typeOfFinalTransactionCompleted)}</h1>
                    </div>
                </div>
            </div>
            <div className="scenario-container text-center" style={{ marginTop: "-100px" }}>
                <div>
                    <h2 style={{ marginBottom: "50px" }}>{getMainMessage(props.text.messagesInstructions, props.typeOfFinalTransactionCompleted, props.errorCode)}</h2>
                </div>
                {
                    props.surveySubmitted
                        ? ratingCompleteComponent()
                        : rateYourExperienceSection()
                }
            </div>
            <div className="text-center" style={{ position: "absolute", bottom: "20px", left: "0", width: "100%" }}>
                <button
                    className="buttons-blue"
                    onClick={() => {
                        if (!props.surveySubmitted) {
                            Client.logPatientDidNotAnswerSurveyEvent();
                        }
                        props.exit()
                    }}
                >
                    {
                        props.text.labels.ExitButton
                    }
                </button>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/SatisfactorySurvery/SatisfactorySurvery.component.tsx